<div class="row">
    <div class="col-sm-6">
        <h4>Lista de fuentes primarias</h4>
    </div>
    <ng-container *ngIf="accessMP===true">
        <div class="col-sm-6 text-end">
            <a [routerLink]="['../../add', idtier3Selected]" class="btn-add">
                <i class="fa fa-plus px-2"></i> Agregar nuevo
            </a>
        </div>
    </ng-container>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Título</th>
                    <th scope="col">URL</th>
                    <th scope="col">Estado</th>
                    <ng-container *ngIf="accessME===true">
                        <th scope="col"></th>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <th scope="col"></th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let o of source; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ o.title }}</td>
                    <td>{{ o.url }}</td>
                    <td class="text-center">
                        <div class="label-active" *ngIf="o.status">ACTIVO</div>
                        <div class="label-inactive" *ngIf="!o.status">INACTIVO</div>
                    </td>
                    <ng-container *ngIf="accessME===true">
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/fuente/edit', o.id]"><i
                                    class="fa fa-pencil i-icon"></i></a></td>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true && !isBlockedTier3">
                        <td class="text-center"><a class="a-icon" routerLink=""><i class="fa fa-trash i-icon"></i></a>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>
</div>